export const userMutationTypes = {
  SET_USER_DATA: 'SET_USER_DATA',
  SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
  SET_USER_LOGOUT: 'SET_USER_LOGOUT',
};
